// @ts-nocheck
/*Карусель изображений*/

import { Swiper } from "swiper";
import { Navigation, Pagination, Thumbs } from "swiper/modules";

let previewsCarousel = null;

const previewsElem = document.querySelector(".image-carousel__preview .swiper");

if (previewsElem) {
    previewsCarousel = new Swiper(previewsElem, {
        modules: [Navigation, Thumbs],
        spaceBetween: 10,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".image-carousel__preview .swiper-button-next",
            prevEl: ".image-carousel__preview .swiper-button-prev",
        },
        on: {
            init: () => {
                previewsElem.parentNode.classList.remove("display-none");
            },
        },
    });
}

const imageCarousel = new Swiper(".image-carousel__images .swiper", {
    modules: [Navigation, Pagination, Thumbs],
    watchOverflow: true,
    navigation: {
        nextEl: ".image-carousel__images .swiper-button-next",
        prevEl: ".image-carousel__images .swiper-button-prev",
    },
    pagination: {
        el: ".image-carousel__images .swiper-pagination",
        clickable: true,
    },
    thumbs:
        previewsCarousel === null
            ? {}
            : {
                  swiper: previewsCarousel,
              },
});

const imageViewCarousel = new Swiper(".image-viewer-carousel .swiper", {
    modules: [Navigation, Pagination, Thumbs],
    watchOverflow: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});

imageCarousel.on("activeIndexChange", (swiper) => {
    imageViewCarousel.slideTo(swiper.activeIndex);
});
